module.exports = __webpack_public_path__ + "static/media/show-notes.05011951.svg";